const FILIERES = { electrotechnique: "BTS Électrotechnique", ciel: "BTS CIEL" };
const STATUS = {
    active: "En cours", promoted: "Passé en 2ème", graduated: "Diplômé", non_graduated: "Non diplômé",
    reoriented: "Réorientation", abandoned: "Abandon", other: "Autre", archived: "Archivé",
};

const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const date = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "—");

function studentRow(s) {
    const c = s.courses;
    return `<tr>
        <td>${esc(s.name)}</td><td>${esc(s.niveau === "2eme" ? "2ème" : "1ère")}</td><td>${esc(STATUS[s.status] || s.status)}</td>
        <td class="n">${s.bilans}</td><td class="n">${s.tutor_evaluations}</td><td class="n">${c.sessions}</td>
        <td class="n">${c.hours.toFixed(1)}</td><td class="n ok">${c.acquis}</td><td class="n mid">${c.partiel}</td>
        <td class="n ko">${c.non_acquis}</td><td class="n">${s.final_bilans}</td>
    </tr>`;
}

export function openQualiopiReport(report) {
    const p = report.promotion;
    const t = report.totals;
    const html = `<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>Dossier de suivi — ${esc(p.name)}</title>
    <style>
        body{font-family:Arial,sans-serif;color:#0a0a0a;margin:32px;font-size:12px}
        h1{font-size:22px;margin:0}.eyebrow{font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:#15A36A}
        .meta{color:#555;margin-top:4px}.kpis{display:flex;gap:10px;margin:20px 0}
        .kpi{border:1px solid #ddd;padding:10px 14px;flex:1}.kpi b{display:block;font-size:20px}
        table{width:100%;border-collapse:collapse;margin-top:10px}th,td{border:1px solid #ddd;padding:6px 8px;text-align:left}
        th{background:#0a0a0a;color:#fff;font-size:10px;text-transform:uppercase}.n{text-align:right}
        .ok{color:#15803d}.mid{color:#b45309}.ko{color:#b91c1c}.note{margin-top:22px;color:#555;font-size:11px;line-height:1.5}
        @media print{body{margin:12mm}}
    </style></head><body>
    <div class="eyebrow">Profawz · Dossier de preuves de suivi pédagogique</div>
    <h1>${esc(p.name)}</h1>
    <div class="meta">${esc(report.establishment_name || "")} · ${esc(FILIERES[p.filiere] || p.filiere)} · ${p.year_start}–${p.year_end} · fin de formation : ${date(p.end_date)}</div>
    <div class="meta">Généré le ${new Date(report.generated_at).toLocaleString("fr-FR")}</div>
    <div class="kpis">
        <div class="kpi"><b>${t.students}</b>étudiants</div>
        <div class="kpi"><b>${t.bilans}</b>bilans d'alternance</div>
        <div class="kpi"><b>${t.tutor_evaluations}</b>évaluations tuteur</div>
        <div class="kpi"><b>${t.sessions}</b>séances évaluées</div>
        <div class="kpi"><b>${t.students_with_followup}/${t.students}</b>suivis en centre et en entreprise</div>
    </div>
    <table><thead><tr>
        <th>Étudiant</th><th>Niveau</th><th>Statut</th><th>Bilans</th><th>Éval. tuteur</th><th>Séances</th>
        <th>Heures</th><th>Acquis</th><th>En cours</th><th>Non acquis</th><th>Bilans finaux</th>
    </tr></thead><tbody>${report.students.map(studentRow).join("") || '<tr><td colspan="11">Aucun étudiant inscrit.</td></tr>'}</tbody></table>
    <p class="note">Ce document rassemble les traces de suivi enregistrées dans Profawz (bilans d'alternance, évaluations des tuteurs, évaluations de compétences en cours/TP, bilans de fin de semestre). Il peut servir de pièce justificative lors d'un audit qualité ; il ne constitue pas en soi une certification.</p>
    <script>window.onload=function(){setTimeout(function(){window.print()},300)}</script>
    </body></html>`;
    const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
}
